export default __webpack_public_path__ + "static/media/cindy.603e81c9.jpeg";